import { LAYOUT } from 'src/providers/ThemeProvider';

export const getCalculatedNavigatorWidth = (): number =>
  document.body.getBoundingClientRect().width * 0.8 -
  (LAYOUT.LeftPanel.size + LAYOUT.RightPanel.size + LAYOUT.Dashboard.margin * 2);
